//我的挂牌自定义详情
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <el-container v-loading="Loading">
      <el-aside width="236px" v-if="leftBanner.length">
        <div :class="{ active: index == chooseIndex }" v-for="(item, index) in leftBanner" :key="index" @click="leftBannerEvt(item, index)">{{ item }}</div>
      </el-aside>
      <el-main class="main-block">
        <div class="top-title">我的投资</div>
        <div class="status-wrap" :class="formData.status == 5 ? 'checkErrorBg' : 'checkSuccessBg'">
          <div class="left">
            <div class="img-warp" :class="formData.status == 5 ? 'checkError' : 'checkSuccess'">
              <img :src="statusImg" alt="" />
            </div>
            <div class="status"> 投资状态<br />
              <p v-if="formData.status == 5" style="color: #ef5147"> {{ formData.status | statusCheck }}</p>
              <p v-else style="color: #91a442"> {{formData.status | statusCheck }}</p>
            </div>
          </div>
        </div>
        <el-form class="form" ref="formRef"  :model="formData" label-width="150px" label-position="right" size="mini">
          <div id="0">
            <div class="h_bg p50">
              <h3>交易信息</h3>
            </div>
            <div class="m50">
              <el-form-item label="摘牌人性质" >
                <span>{{formData.userType == 1 ? '个人' : '企业'}}</span>
              </el-form-item>
              <el-form-item label="姓名" >
                <span>{{formData.name}}</span>
              </el-form-item>
              <el-form-item label="身份证号" v-if="formData.identityCode">
                <span>{{formData.identityCode}}</span>
              </el-form-item>
              <el-form-item label="联系电话" v-if="formData.contactPhone">
                <span>{{formData.contactPhone}}</span>
              </el-form-item>
              <el-form-item label="公司信用代码" v-if="formData.creditCode">
                <span>{{formData.creditCode}}</span>
              </el-form-item>
              <el-form-item label="公司地址" v-if="formData.registAddress">
                <span>{{formData.registAddress}}</span>
              </el-form-item>
              <el-form-item label="开户银行" >
                <span>{{formData.openBank}}</span>
              </el-form-item>
              <el-form-item label="银行账号" >
                <span>{{formData.bankAccount}}</span>
              </el-form-item>
              <el-form-item label="是否保证金抵扣" >
                <span>{{formData.usePromiseAmount ? "是":"否"}}</span>
              </el-form-item>
              <el-form-item label="摘牌时间" > 
                <span>{{formData.delistingTime}}</span>
              </el-form-item>
              <el-form-item label="摘牌方式" >
                <span>{{formData.delistingType == 1 ? '全额付款' : formData.delistingType == 2 ? '预付款' : formData.delistingType == 3 ? '交付后付款' : formData.delistingType == 4 ? '其他' : '自行转账'}}</span>
              </el-form-item>
              <el-form-item label="成交价格（元）" >
                <span>{{formData.transactionPrice}}</span>
              </el-form-item>
              <div v-if="formData.paymentInfo">
                <el-form-item label="预付款金额" v-if="formData.delistingType == 2 ">
                  <span>{{formData.paymentInfo.amount}}</span>
                </el-form-item>
                <el-form-item label="付款时间" >
                  <span>{{formData.paymentInfo.createdTime}}</span>
                </el-form-item>
                <el-form-item label="转账方式" >
                  <span>{{formData.paymentInfo.payMethod == 1 ? '代收代付' :formData.paymentInfo.payMethod == 2 ? '自行转账' :formData.paymentInfo.payMethod == 3 ? '结算支付' : '---'}}</span>
                </el-form-item>
                <el-form-item label="转账凭证" v-if="formData.paymentInfo.fileUrl && formData.paymentInfo.fileUrl.length">
                  <el-image v-for="(item, index) in formData.paymentInfo.fileUrl" :key='index'
                    style="width: 100px; height: 100px" :src="item" :preview-src-list="[item]">
                  </el-image>
                </el-form-item>
              </div>
              <div v-if="formData.usePromiseAmount && formData.promiseAmountInfo">
                <el-form-item label="保证金金额（元）" >
                  <span>{{formData.promiseAmountInfo.amount}}</span>
                </el-form-item>
                <el-form-item label="付款时间" >
                  <span>{{formData.promiseAmountInfo.createdTime}}</span>
                </el-form-item>
                <el-form-item label="转账方式" >
                  <span>{{formData.promiseAmountInfo.payMethod == 1 ? '代收代付' :formData.promiseAmountInfo.payMethod == 2 ? '自行转账' :formData.promiseAmountInfo.payMethod == 3 ? '结算支付' : '---'}}</span>
                </el-form-item>
                <el-form-item label="转账凭证" v-if="formData.promiseAmountInfo.fileUrl && formData.promiseAmountInfo.fileUrl.length">
                  <el-image v-for="(item, index) in formData.promiseAmountInfo.fileUrl" :key='index'
                    style="width: 100px; height: 100px" :src="item" :preview-src-list="[item]">
                  </el-image>
                </el-form-item>
              </div>
              <div v-if="formData.finalPaymentInfo">
                <el-form-item label="尾款金额（元）" >
                  <span>{{formData.finalPaymentInfo.amount}}</span>
                </el-form-item>
                <el-form-item label="付款时间" >
                  <span>{{formData.finalPaymentInfo.createdTime}}</span>
                </el-form-item>
                <el-form-item label="转账方式" >
                  <span>{{formData.finalPaymentInfo.payMethod == 1 ? '代收代付' :formData.finalPaymentInfo.payMethod == 2 ? '自行转账' :formData.finalPaymentInfo.payMethod == 3 ? '结算支付' : '---'}}</span>
                </el-form-item>
                <el-form-item label="转账凭证" v-if="formData.finalPaymentInfo.fileUrl && formData.finalPaymentInfo.fileUrl.length">
                  <el-image v-for="(item, index) in formData.finalPaymentInfo.fileUrl" :key='index'
                    style="width: 100px; height: 100px" :src="item" :preview-src-list="[item]">
                  </el-image>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <div id="1" v-if="formData.contractFiles && formData.contractFiles.length">
          <div class="h_bg p50">
            <h3>相关合同</h3>
          </div>
          <div class="m50">
            <el-form class="form">
              <el-row class="mt20">
                <el-col v-for="item of formData.contractFiles" :key="item.id">
                  <div v-if="item.fileUrl.length == 1">
                    <el-form-item :label="item.fileName"  label-width="390px" style="margin-bottom: 0">
                      <DataUpload style="display: inline-block; margin-left: 50px" :fileFuther="item" :downFlag="false"  />
                    </el-form-item>                
                  </div>
                  <div v-else>
                    <el-form-item :label="`${item.fileName}(可上传多份)`"   label-width="390px"  style="margin-bottom: 0;">
                      <ListUpload  style="display: inline-block; margin-left:50px;" :fileFuther="item"  :downFlag="false"  />
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div :id="formData.contractFiles && formData.contractFiles.length > 0 ? '2' : '1'" v-if="formData.delistingFiles && formData.delistingFiles.length">
          <div class="h_bg p50">
            <h3>相关资料</h3>
          </div>
          <div class="m50">
            <el-form class="form">
              <el-row class="mt20">
                <!-- v-if="info.delistingFiles && info.delistingFiles.length -->
                <el-col v-for="item of formData.delistingFiles " :key="item.id">
                  <div v-if="item.fileUrl.length == 1">
                    <el-form-item :label="item.fileName"  label-width="390px" style="margin-bottom: 0">
                      <DataUpload style="display: inline-block; margin-left: 50px" :fileFuther="item" :downFlag="false"  />
                    </el-form-item>                
                  </div>
                  <div v-else>
                    <el-form-item :label="`${item.fileName}(可上传多份)`"   label-width="390px"  style="margin-bottom: 0;">
                      <ListUpload  style="display: inline-block; margin-left:50px;" :fileFuther="item"  :downFlag="false"  />
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="btn_wrap">
          <el-button class="btns black" @click="$router.go(-1)">返回</el-button>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import DataUpload from '@/components/DataUpload/OneUpload.vue';
import ListUpload from '@/components/DataUpload/ListUpload.vue';
import HeaderImg from '@/components/HeaderImg';
import ErrorImg from '@/assets/img/check_error.png';
import SuccessImg from '@/assets/img/check_success.png';
export default {
  name:'InvestDetail',
  components: {
    DataUpload,
    ListUpload,
    HeaderImg,
  },
  data() {
    return {
      formData: {
        bankAccount: "",
        contactPhone: "",
        contractFiles: [],
        delistingFiles : [],
        creditCode: "",
        delistingTime: "",
        delistingType: "",
        identityCode: "",
        name: "",
        openBank: "",
        payMethod:"",
        payTime: "",
        paymentVouchers: "",
        registAddress: "",
        status: "",
        transactionPrice: "",
        usePromiseAmount: "",
        userType: "",
      },
      headerList: [
        { name: "首页", path: "/Home" },
        { name: '我的投资', path: '/myInvest' },
        { name: '投资详情', path: '' }],
      leftBanner: ['交易信息',],
      chooseIndex: 0,
      statusImg: ErrorImg,
      roleFileList: [], //当前角色文件列表
      downFlag: true,
      areaStatus: [], //
      Loading: false, //
      orNo:false,
    };
  },
  filters: {
    statusCheck: (str) => {
      if (str == 5) {
        return '未成交'
      }else if (str == 6) {
        return '已成交'
      } else {
        return '已摘牌'
      }
      return ''
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.getTableData(); // 获取详情信息
  },
  methods: {
    // 获取详情数据
    async getTableData() {
      await this.$api.my.investmentDetail({ id: this.$route.query.id, }).then((res) => {
          if (res.code == 1000) {
            this.formData = res.data
            if (this.formData.status == 5) {
              this.statusImg = ErrorImg;
            } else {
              this.statusImg = SuccessImg;                
            }
            if(this.formData.delistingFiles && this.formData.delistingFiles.length){
              this.leftBanner.push('相关资料')
              this.formData.delistingFiles .forEach(item=>{
                this.$set(item, 'status', true)
                this.$set(item, 'fileList', [])
                if(item.fileUrl.length ==  1){
                  item.fileList.push({
                    fileName: item.fileName,
                    fileUrl: item.fileUrl[0],
                    fileType: item.fileType
                  })
                } else {
                  item.fileUrl.forEach(i=>{
                    item.fileList.push({
                      fileName: item.fileName,
                      fileUrl: i,
                      fileType: item.fileType
                    })
                  })
                }
              })
            }
            if(this.formData.contractFiles && this.formData.contractFiles.length){
                this.leftBanner.push('相关合同')
                this.formData.contractFiles.forEach(item=>{
                  this.$set(item, 'status', true)
                  this.$set(item, 'fileList', [])
                  if(item.fileUrl.length ==  1){
                    item.fileList.push({
                      fileName: item.fileName,
                      fileUrl: item.fileUrl[0],
                      fileType: item.fileType
                    })
                  } else {
                    item.fileUrl.forEach(i=>{
                      item.fileList.push({
                        fileName: item.fileName,
                        fileUrl: i,
                        fileType: item.fileType
                      })
                    })
                  }
                //   if (this.status != 0) {
                //     item.status = item.flag;
                //   }
              })
            }
          }
        }).catch((error) => {}).finally(() => {
          this.Loading = false;
        });
    },
    leftBannerEvt(item, index) {
      var el = document.getElementById(index);
      this.chooseIndex = index;
      if (index != 0) {
        this.$nextTick(function () {
          window.scrollTo({ behavior: 'smooth', top: el.offsetTop });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-container {
  width: auto;
  max-width: 1200px;
  margin: 0 auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  .el-aside {
    div {
      background: #fff;
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #3e4860;
      margin-bottom: 5px;
    }
    .active {
      background: url('~@/assets/navBarselected.png') no-repeat;
      color: #fff;
    }
  }
}

.main-block {
  width: auto;
  max-width: 1200px;
  margin: auto 10px;
  background: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 !important;
  .top-title {
    margin: 20px !important;
  }
  .status-wrap {
    height: 110px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.checkErrorBg {
      background: #fef0f2;
    }
    &.checkingBg {
      background: #fef9f0;
    }
    &.checkSuccessBg {
      background: #f0f9f0;
    }
    .left {
      display: flex;
      align-items: center;
      .status {
        margin-left: 35px;
        p {
          margin: 0;
          font-size: 20px;
          .errorFont {
            font-size: 16px;
            color: #60697e;
            padding-left: 15px;
          }
        }
      }
      .img-warp {
        width: 110px;
        height: 110px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.checking {
          background: #ffaa36;
        }
        &.checkSuccess {
          background: #91a442;
        }
        &.checkError {
          background: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
        }
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
    }
  }
  .h_bg {
    margin: 0 0 30px;
  }
  .form{
    span{
      padding-left: 20px;
    }
  }
}

</style>
